import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CertificateCard, CertificateIcon } from '../styles/CertificationsStyles';
import { useCertifications } from '../utils/CertificationsUtils';

const CertificationsComp = () => {
  const theme = useTheme();
  const { title, certifications } = useCertifications();

  return (
    <Container maxWidth="lg" sx={{ 
      py: 8, 
      background: theme.palette.mode === 'dark' 
        ? (theme.custom?.gradients?.sectionPrimaryDark || theme.custom?.gradients?.appBackgroundDark) 
        : 'inherit'
    }} id="certifications">
      <Typography variant="h3" gutterBottom align="center" sx={{ 
        mb: 6, 
        fontWeight: 'bold', 
        background: theme.palette.mode === 'dark'
          ? (theme.custom?.gradients?.brandTextDark || theme.custom?.gradients?.brand)
          : 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        textShadow: theme.palette.mode === 'dark'
          ? '2px 2px 4px rgba(0,0,0,0.5)'
          : '2px 2px 4px rgba(0,0,0,0.1)',
      }}>
        {title}
      </Typography>
      <Grid container spacing={4}>
        {certifications.map((cert, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <CertificateCard elevation={3}>
              <CertificateIcon />
              <Typography variant="h6" gutterBottom sx={{ 
                fontWeight: 'bold', 
                color: theme.palette.mode === 'dark' ? '#ffffff' : theme.palette.primary.main 
              }}>
                {cert.title}
              </Typography>
              <Typography variant="subtitle1" gutterBottom sx={{
                color: theme.palette.mode === 'dark' ? '#ecf0f1' : 'inherit'
              }}>
                {cert.issuer}
              </Typography>
              <Typography variant="body2" sx={{
                color: theme.palette.mode === 'dark' ? '#bdc3c7' : 'textSecondary'
              }}>
                {cert.date}
              </Typography>
              <Box mt={2}>
                <Typography variant="body2" sx={{ 
                  fontStyle: 'italic', 
                  color: theme.palette.mode === 'dark' ? '#95a5a6' : 'text.secondary' 
                }}>
                </Typography>
              </Box>
            </CertificateCard>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default CertificationsComp;
